export const addOpacityToColorHex = (colorHex: string, opacity: number) => {
  const opacityString = Math.round(opacity * 255).toString(16);
  return (
    colorHex + (opacityString.length < 2 ? '0' + opacityString : opacityString)
  );
};
